import {apiAxios} from "@/service/APIClient";
import TournamentLeaderboardDTO from "@/models/TournamentLeaderboardDTO";
import PaginationDTO from "@/models/PaginationDTO";
import PaginatedResponseDTO from "@/models/PaginatedResponseDTO";
import TournamentAchievementDTO from "@/models/TournamentAchievementDTO";
import qs from "qs";
import TournamentDTO from "@/models/TournamentDTO";

export const tournaments = {
    achievements: async (pagination: PaginationDTO): Promise<PaginatedResponseDTO<TournamentAchievementDTO>> => {
        let resp = await apiAxios({
            url: `/tournaments/achievements`,
            method: 'GET',
            params: {
                limit: pagination.limit,
                offset: pagination.offset,
            },
            paramsSerializer: params => {
                return qs.stringify(params)
            }
        })

        return resp.data as PaginatedResponseDTO<TournamentAchievementDTO>
    },
    get: async (id: number): Promise<TournamentDTO> => {
        let resp = await apiAxios({
            url: `/tournaments/${id}`,
            method: 'GET',
        })

        return resp.data as TournamentDTO
    },
    leaderboard: async (id: number): Promise<TournamentLeaderboardDTO> => {
        let resp = await apiAxios({
            url: `/tournaments/${id}/leaderboard`,
            method: 'GET',
        })

        return resp.data as TournamentLeaderboardDTO
    },
    join: async (id: number): Promise<void> => {
        await apiAxios({
            url: `/tournaments/${id}/join`,
            method: 'POST',
        })
    },
    claim: async (id: number): Promise<void> => {
        await apiAxios({
            url: `/tournaments/${id}/claim`,
            method: 'POST',
        })
    },
}